/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import actions from 'redux/actions';
import { getUsage } from 'redux/reducers/usages';

import UsageForm from 'forms/UsageForm';
import DataLoader from 'components/DataLoader';
import styles from './styles.module.scss';

import { get, defaultTo } from 'lodash';
import protonesUtils from 'utils/protones';
import { withTranslation } from 'react-i18next';

import type {
  Translate,
  ReactRouterProps,
  Fetchable,
  Usage,
  SaveUsageParams,
  ReduxState,
} from 'types';

const mapStateToProps = (state: ReduxState, ownProps) => {
  const usageId = ownProps.match.params.usageId;
  const isNew = usageId === 'create';
  return {
    usageId,
    usage: getUsage(state),
    isNew,
    ...ownProps,
  };
};

type Props = ReactRouterProps & {
  usageId?: string,
  usage: Fetchable<Usage>,
  isNew: boolean,
  saveUsage: typeof actions.saveUsage,
  fetchUsageList: typeof actions.fetchUsageList,
  t: Translate,
};

class UsageEdit extends React.Component<Props, void> {
  _handleSaveUsage = (params: SaveUsageParams) => {
    this.props.saveUsage(params, (usage: Usage) => {
      this.props.fetchUsageList();
      protonesUtils.goTo(this.props, protonesUtils.routes.usages.get(usage.id));
    });
  };

  _getUsageFormTitle() {
    const {
      usage: { data },
      isNew,
      usageId,
      t,
    } = this.props;
    if (isNew) {
      return t('DEFINE_NEW_USAGE');
    } else if (data && data.name) {
      return !usageId ? `Usage: ${data.name || ''}` : data.name;
    } else {
      return '';
    }
  }

  _renderUsageData = data => {
    const {
      usage: { fetching },
    } = this.props;
    const initialValues = {
      id: defaultTo(get(data, 'id'), ''),
      name: defaultTo(get(data, 'name'), ''),
      startDate: defaultTo(get(data, 'startDate'), null),
      endDate: defaultTo(get(data, 'endDate'), null),
      notes: defaultTo(get(data, 'notes'), ''),
      productionId: defaultTo(get(data, 'production.id'), ''),
      episode: defaultTo(get(data, 'episode'), ''),
      quantity: defaultTo(get(data, 'quantity'), ''),
      territoryId: defaultTo(get(data, 'territory.id'), ''),
      usageTypeId: defaultTo(get(data, 'usageType.id'), ''),
    };
    return (
      <UsageForm
        form={'usage'}
        initialValues={initialValues}
        isLoading={fetching}
        title={this._getUsageFormTitle()}
        actionButtonsVisible={true}
        save={this._handleSaveUsage}
      />
    );
  };

  render() {
    const {
      usage: { fetching, error, data },
    } = this.props;
    return (
      <div className={styles.content}>
        <DataLoader
          loading={fetching}
          error={error}
          data={data}
          render={this._renderUsageData}
          fallback={this._renderUsageData}
        />
      </div>
    );
  }
}

export default withTranslation()(
  withRouter(
    connect(
      mapStateToProps,
      actions
    )(UsageEdit)
  )
);
